import React, {useState} from 'react';
import {Link} from 'react-router-dom'
import DatePicker, {registerLocale} from "react-datepicker";
import es from "date-fns/locale/es";
registerLocale("es",es);

// Inicio de hoy: cualquier fecha anterior no es elegible.
const startOfToday = () => {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    return d;
};
const isPast = (date) => !date || date < startOfToday();

// emptyStart: sin fecha preseleccionada (el cliente debe elegirla). Sin la
// prop, empieza en hoy como siempre (otras pantallas lo usan así).
const Calendar  = ({handleDateChange, emptyStart}) => {
    const [startDate, setStartDate] = useState(emptyStart ? null : new Date());
    const min_date = new Date();
      const filterDays = (date) => {
        // Disable Weekends
        if (date.getDay() === 0 || date.getDay() === 7) {
            return false;
        } else {
            return true;
        }
    }
    // minDate ya deshabilita los días pasados en el calendario; esto cubre
    // además una fecha escrita a mano en el campo.
    return (
      <DatePicker
        selected={startDate}
        locale="es"
        dateFormat="dd/MM/yyyy"
        minDate={min_date}
        onChange={date => { if (!isPast(date)) setStartDate(date); }}
        onSelect={date => { if (!isPast(date)) handleDateChange(date); }}
        filterDate={filterDays}
        placeholderText="Elige la fecha"
      />
    );
  };

export default Calendar;
